// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "campaign_event".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { campaignEventTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "campaign_event" table (1:1 with a DB row, on the wire). */
export const campaignEventAtomSchema = z.object({
    id: z.string(),
    campaignId: z.string(),
    recipientId: z.string().nullable(),
    type: z.enum(campaignEventTypeValues),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=campaignEvent.js.map